module.exports = __webpack_public_path__ + "img/netstar-companion.cff2a092.svg";